import type { Metric } from "web-vitals";
import type { GAConsentSettings } from "./types";

function updateGaConsentSettings(vals: GAConsentSettings) {
  if (typeof gtag !== "undefined") gtag("consent", "update", vals);
}
const GA_CONSENT_SETTINGS_KEY = "polygraf-ga-consent-settings" as const;
export function setGaConsentSettings(vals: GAConsentSettings) {
  localStorage.setItem(GA_CONSENT_SETTINGS_KEY, JSON.stringify(vals));
  updateGaConsentSettings(vals);
}
export function getGaConsentSettings(): GAConsentSettings | null {
  const val = localStorage.getItem(GA_CONSENT_SETTINGS_KEY);
  if (val === null) return null;

  try {
    return JSON.parse(val) as GAConsentSettings;
  } catch {
    setGaConsentSettings({});
    return {};
  }
}

export function sendWebVitals({ name, delta, value, id }: Metric) {
  const eventParams = {
    // Built-in params:
    value: delta, // Use `delta` so the value can be summed.
    // Custom params:
    metric_id: id, // Needed to aggregate events.
    metric_value: value, // Optional.
    metric_delta: delta, // Optional.
  };

  if (typeof gtag !== "undefined") gtag("event", name, eventParams);
}

export const initGaConsentSettings = () => {
  const existingSettings = getGaConsentSettings();
  if (existingSettings) updateGaConsentSettings(existingSettings);
};
